export const projectURL = "https://auth.vetworks.io";
export const projectKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmbHVmanBveXRqZXhjbXBvbmlrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDM0NTI5NTcsImV4cCI6MjAxOTAyODk1N30.pGs-6h3KMjXq3wWfdwJQXHVDnF1A_Zjweq02fYLBFHc";
